import { render, staticRenderFns } from "./timestamp-format.vue?vue&type=template&id=1dd96f82&"
import script from "./timestamp-format.vue?vue&type=script&lang=js&"
export * from "./timestamp-format.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports